const dsn = import.meta.env.VITE_SENTRY_LARAVEL_DSN;

if (dsn) {
    import("@sentry/browser").then((Sentry) => {
        Sentry.init({
            dsn,
            sendDefaultPii: false,
            debug: import.meta.env.DEV,
            environment: import.meta.env.MODE,
        });
    });
}
